import { styled } from 'styled-components';

import BusinessNumaLogo from './numa-logo-business';
import NumaLogo from './numa-logo-cropped';
import { Wrapper } from './styles';
import { LogoProps } from './types';

const Logo = ({ className, src, name, isBusiness }: LogoProps) => {
  const logo = isBusiness ? <BusinessNumaLogo /> : <NumaLogo />;
  const children = src ? <img src={src} alt={name} /> : logo;

  return <Wrapper className={className}>{children}</Wrapper>;
};
export default styled(Logo)``;
